import { BaseType } from '../base/base-type';
import { LifeStatusTypeIdEnum } from './enum/life-status-type-id.enum';

export class LifeStatusType extends BaseType {
  public declare id: LifeStatusTypeIdEnum;
}
